export class ExportAlreadyInProgressError extends Error {
  public constructor() {
    super()

    this.message = 'errors.exportAlreadyInProgress'
  }
}
